export default __webpack_public_path__ + "static/media/pic3.326a355a.jpg";